(function () {
  var SHARE_SVG =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function bind(root) {
    var btn = root.querySelector('[data-blog-post-puzzery-share]');
    if (!btn || btn.getAttribute('data-blog-post-puzzery-share-bound') === 'true') return;
    btn.setAttribute('data-blog-post-puzzery-share-bound', 'true');
    var defaultHtml = btn.innerHTML;

    btn.addEventListener('click', function () {
      var currentUrl = window.location.href;
      var sep = currentUrl.indexOf('?') !== -1 ? '&' : '?';
      var urlWithUtm =
        currentUrl +
        sep +
        'utm_source=share&utm_medium=article&utm_campaign=share_button';

      function restore() {
        btn.innerHTML = defaultHtml;
      }

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        window.prompt('Copy link:', urlWithUtm);
        return;
      }

      navigator.clipboard.writeText(urlWithUtm).then(function () {
        btn.innerHTML = 'Link copied! ' + SHARE_SVG;
        window.setTimeout(restore, 3000);
      }).catch(function () {
        window.prompt('Copy link:', urlWithUtm);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-blog-post-puzzery-root]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
